<template>
  <div class="animated fadeIn page-new">
    <b-row>
      <b-form @submit.prevent="save" action="111" class="col-md-12">
        <b-row>
          <b-col sm="12" class="main-page">
            <b-card footer-tag="footer">
              <div slot="header">
                <b-row>
                  <b-col><span>Chi tiết cổ phiếu </span> <strong class="text-danger pl-3" v-if="data.code">{{
                      data.code
                    }}</strong>
                    <em class="text-muted px-5" v-if="data && data.updated">Cập nhập:
                      {{ formatDateDiff(data.updated) }} vào lúc {{ formatDate(data.updated) }}</em>
                    <p class="mt-3">Tên công ty: <b class="ml-3">{{ data.CompanyName }}</b></p></b-col>
                  <b-col v-if="isSuperAdmin">
                    <b-button size="sm" variant="danger" class="pull-right" @click="showDeleteModal">
                      <i class="icon cui-trash"></i>
                      Xóa Cổ phiếu
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <b-row v-bind:class="{'ptt-loading':loading}">
                <b-col cols="12" xl="6">
                  <b-table small hover :items="columns[0]" :fields="fields2" responsive="sm">
                    <template slot="label" slot-scope="option">
                      {{ option.item.label|removeBr }}
                    </template>
                    <template slot="value" slot-scope="option">
                      {{ option.item.value }}
                    </template>
                  </b-table>

                </b-col>
                <b-col cols="12" xl="6">
                  <b-table small hover :items="columns[1]" :fields="fields2" responsive="sm">
                    <template slot="label" slot-scope="option">
                      {{ option.item.label|removeBr }}
                    </template>
                    <template slot="value" slot-scope="option">

                      <template v-if="option.item.key && option.item.key === 'TieuChiZ' && isSuperAdmin">
                        <b-form-input size="sm"
                                      class="pull-right text-right"
                                      @input="handleZChange"
                                      :class="{'border-red': hasZChanged}"
                                      v-model="indexZ" type="number"/>
                      </template>
                      <template v-else>
                        {{ formatter(option.item) }}
                      </template>
                    </template>
                  </b-table>
                </b-col>
              </b-row>

              <div slot="footer" class="">
                <b-row>
                  <b-col>
                    <b-button type="button" :to="{path:'/stock'}">Quay lại</b-button>
                  </b-col>
                  <b-col align="right" v-if="isSuperAdmin">
                    <b-button variant="danger" class="resetIndicesB mr-2" @click.prevent="resetIndexZ"
                              :disabled="indexZDisabled">Đặt lại
                    </b-button>
                    <b-button variant="success" class="saveIndicesB" @click.prevent="saveIndexZ"
                              :disabled="indexZDisabled">Lưu thay đổi
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </b-row>
    <!-- Modal Xác Nhận Xóa -->
    <b-modal id="delete-modal" ref="deleteModal" title="Xác nhận xóa"
             ok-title="Xác nhận" cancel-title="Bỏ qua"
             @ok="deleteStock" size="sm">
      <p class="my-4">Bạn có muốn xóa cổ phiếu <template>{{data.code||'này'}}</template>  không?</p>
    </b-modal>
  </div>
</template>

<script>
import fields from '@/utils/fields'
import moment from 'moment-timezone';
import {isAuth, isSuperAdmin, getUser} from "@/utils/auth";

export default {
  name: 'StockDetail',
  components: {},
  data() {
    return {
      data: {},
      keys: [],
      fields: [],
      fields2: [
        {key: "order", label: "STT"},
        {key: "label", label: "Tiêu chí"},
        {key: "value", label: "Giá trị"},
        {key: "index_a", label: "Điểm số A", thClass: 'text-right', tdClass: 'text-right'},
        {key: "index_b", label: "Trọng số B", thClass: 'text-right', tdClass: 'text-right'},
      ],
      loading: false,
      indexZDisabled: false,
      indexZ: null,
      hasZChanged: false,
    }
  },
  created() {
    this.fetchData();

  },
  computed: {
    isAdmin() {
      return isAuth()
    },
    isSuperAdmin() {
      return isSuperAdmin()
    },
    columns() {
      let col1 = [];
      let col2 = [];
      let segments = []

      col1.push(
        {order: 1, label: "Sàn", value: this.data.San, index_a: this.data.San_A, index_b: this.data.San_A},
        {
          order: 2,
          label: "Ngành hàng",
          value: this.data.NganhHang || '',
          index_a: this.data.NganhHang_A || '',
          index_b: this.data.NganhHang_B || ''
        },
        {order: 2.1, label: "Ngành hàng cấp 1", value: this.data.NganhHangCap1 || '', index_a: null, index_b: null},
        {order: 2.2, label: "Ngành hàng cấp 2", value: this.data.NganhHangCap2 || '', index_a: null, index_b: null},
        {order: 2.3, label: "Ngành hàng cấp 3", value: this.data.NganhHangCap3 || '', index_a: null, index_b: null},
        {order: 2.4, label: "Ngành hàng cấp 4", value: this.data.NganhHangCap4 || '', index_a: null, index_b: null},
        {order: 2.5, label: "Ngành hàng cấp 5", value: this.data.NganhHangCap5 || '', index_a: null, index_b: null},
        {order: 2.6, label: "Ngành hàng cấp 6", value: this.data.NganhHangCap6 || '', index_a: null, index_b: null},
      )

      segments = fields.filter(item => {
        let order = parseInt(item.order)
        return order >= 3 && order <= 50
      }).map(item => {
        if (item?.key) {
          if (this.data[item.key + '_A']) {
            item.index_a = this.data[item.key + '_A']
          }
          if (this.data[item.key + '_B']) {
            item.index_b = this.data[item.key + '_B']
          }
        }
        return {
          order: parseInt(item.order),
          key: item.key,
          label: item.label,
          value: this.data[item.key] || null,
          index_a: item.index_a || null,
          index_b: item.index_b || null,
          formatter: item.formatter || null
        }
      })
      col1 = [...col1, ...segments]

      segments = fields.filter(item => {
        let order = parseInt(item.order)
        return order >= 51 && order <= 100
      }).map(item => {
        if (item?.key) {
          if (this.data[item.key + '_A']) {
            item.index_a = this.data[item.key + '_A']
          }
          if (this.data[item.key + '_B']) {
            item.index_b = this.data[item.key + '_B']
          }
        }
        return {
          order: parseInt(item.order),
          key: item.key,
          label: item.label,
          value: this.data[item.key] || null,
          index_a: item.index_a || null,
          index_b: item.index_b || null,
          formatter: item.formatter
        }
      })
      col2 = [...col2, ...segments]

      return [col1, col2];
    }
  },
  watch: {},
  methods: {
    async fetchData() {
      let id = this.$route.params.id;
      if (!id) {
        this.$toasted.error("Không tải được dữ liệu", {
          duration: 3000
        });
        this.$router.push({path: "/stock"});
        return false;
      }
      this.loading = true;
      try {
        let {data} = await this.$axios.get(this.$configs.api + `/api/v1/cp/stocks/${id}`)

        if (data && data._id && data.code) {
          this.data = data
          this.indexZ = data?.TieuChiZ
          this.keys = Object.keys(this.data)
          this.getKeyInfo()
        }
        const user = this.$cookies.get('user');
        this.$gtag.event('view_stock_details', {
          event_category: 'click_events',
          event_label: 'View stock button',
          user_type: 'admin',
          user_id: user?._id,
          req: id,
          res: JSON.stringify(data || {})
        });
      } catch (err) {
        // this.$router.push({path: "/stock"});
        // return false;
      } finally {
        this.loading = false;
      }

    },
    getKeyInfo() {
      this.fields = this.keys
        .map(k => fields.find(obj => obj.key === k))
        .filter(item => item !== undefined && item.key && item.key !== 'code' && item.key !== 'CompanyName')
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    },
    formatDateDiff(date) {
      const currentDate = moment().tz('Asia/Ho_Chi_Minh');
      const targetDate = moment(date).tz('Asia/Ho_Chi_Minh');
      const diffDays = currentDate.diff(targetDate, 'days');

      if (diffDays === 0) {
        return "hôm nay";
      } else if (diffDays === 1) {
        return "hôm qua";
      } else {
        return `${diffDays} ngày trước`;
      }
    },
    formatDate(date) {
      return moment(date).tz('Asia/Ho_Chi_Minh').format('DD-MM-YYYY H:mm');
    },
    resetIndexZ() {
      if (this.data?.TieuChiZ) {
        this.indexZ = this.data.TieuChiZ
      }
    },
    async saveIndexZ() {
      if (this.indexZ !== null) {
        this.indexZDisabled = "disabled"
        try {
          let params = {
            id: this.data._id,
            code: this.data.code,
            z: parseFloat(this.indexZ)
          }
          let {data} = await this.$axios.post(this.$configs.api + '/api/v1/cp/stocks/save-index-z', params)

          if (data?.status === true) {
            this.$toasted.info("Đã lưu thay đổi Tiêu Chí Z", {
              duration: 2000
            });
            //this.resetIndicesB(false)
          }

        } catch (e) {
          this.$toasted.error("Đã có lỗi khi lưu thay đổi Tiêu Chí Z", {
            duration: 2000
          });
        } finally {
          setTimeout(() => {
            this.indexZDisabled = null
          }, 500)
        }
      }
    },
    formatter(item) {
      if (item?.formatter) {
        return item.formatter(item.value)
      } else {
        return item.value
      }
    },
    handleZChange() {
      this.hasZChanged = true
    },
    showDeleteModal() {
      this.$refs.deleteModal.show();
    },
    async deleteStock() {
      if (!this?.data?._id) {
        return;
      }
      try {
        let {data} = await this.$axios.delete(this.$configs.api + '/api/v1/cp/stocks/' + this.data._id);
        if (data?._id) {
          this.$router.push('/stock');
          this.$toasted.info(`Đã xóa cổ phiếu ${this.data.code}.`, {duration: 3000})
        }
      } catch (e) {
        this.$toasted.error(`Đã có lỗi khi xóa cổ phiếu ${this.data.code}.`, {duration: 3000})
      }
    },
  },
  filters: {
    removeBr(value) {
      if (!value) return '';
      return value.replace(/<br\s*\/?>/gi, ' '); // Thay thế bằng dấu cách hoặc '\n' cho xuống dòng
    }
  },
}
</script>
<style>
.pre-formatted {
  white-space: pre;
}

[type="number"].border-red {
  border-color: orange;
}
</style>

